export type AsyncOperation<TResult> = () => Promise<TResult>;

/**
 * Share one active async operation across concurrent callers.
 *
 * The active promise is published synchronously before another UI event can
 * enter the gate. It is cleared after either resolution or rejection so a
 * later, intentional attempt can run normally.
 */
export function createSingleFlight<TResult>() {
  let active: Promise<TResult> | null = null;

  return (operation: AsyncOperation<TResult>): Promise<TResult> => {
    if (active) return active;

    const pending = operation();
    active = pending;
    const clear = () => {
      if (active === pending) active = null;
    };
    void pending.then(clear, clear);
    return pending;
  };
}
